/* Close a popover / drawer on Escape, and (when a ref is given) on a click
 * outside it. One copy for the table toolbar popovers (Columns, Saved views)
 * and the bulk grid's menu and Columns drawer, which each carried their own.
 * When the shared overlay kit (components/overlay, feat/redesign-fe-pages)
 * lands on main, these move onto its Popover/Drawer and this file goes.
 */
import { useEffect } from 'react'

export function useDismiss(
  open: boolean,
  close: () => void,
  ref?: React.RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') close() }
    const onDown = (e: MouseEvent) => {
      if (ref?.current && !ref.current.contains(e.target as Node)) close()
    }
    document.addEventListener('keydown', onKey)
    if (ref) document.addEventListener('mousedown', onDown)
    return () => {
      document.removeEventListener('keydown', onKey)
      if (ref) document.removeEventListener('mousedown', onDown)
    }
  }, [open, close, ref])
}
